var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"we-toggle-text small "},[_c('div',{staticClass:"fast-filter-text",class:{
            active: this.fastFilterDateInterval === 'users',
        },on:{"click":function($event){return _vm.manageFastFilterSelected('users')}}},[_vm._v("\n        Usuarios\n    ")]),_c('div',{staticClass:"fast-filter-text",class:{
            active: this.fastFilterDateInterval === 'admin',
        },on:{"click":function($event){return _vm.manageFastFilterSelected('admin')}}},[_vm._v("\n        Admin\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }